import React from "react";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";
import { useFormatAmount } from "src/business-types/laundry/modules/home/hooks/useFormatAmount";
import { Order, OrderedProduct } from "src/shared/services/interfacev2";

interface TableRow {
  id: number;
  sno: number;
  name: string;
  price: string | number;
  qty: number;
  total: string;
}

interface OrderItemsTableProps {
  order: Order;
}

const OrderItemsTable: React.FC<OrderItemsTableProps> = ({ order }) => {
  const formatAmount = useFormatAmount();
  const allProducts: OrderedProduct[] =
    order?.orderDetails?.[0]?.products ?? [];

  const tableData: TableRow[] = allProducts.map((p, index) => {
    const price = Number(p.unitPrice) || 0;
    const qty = p.quantity || 1;

    return {
      id: index + 1,
      sno: index + 1,
      name: p.name,
      price: formatAmount(price),
      qty,
      total: formatAmount(Number(p.lineTotal) || price * qty),
    };
  });

  const headCells: HeadCell<TableRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "name", label: "Product" },
    { id: "price", label: "Price (QAR)", align: "right" },
    { id: "qty", label: "Qty", align: "center" },
    { id: "total", label: "Total (QAR)", align: "right" },
  ];

  return (
    <CommonTable
      data={tableData}
      headCells={headCells}
      title="Order Items"
      selectable={false}
      pagenation={true}
      showToolbar={false}
      pageSize={10}
      className="w-full shadow-inner rounded-lg bg-white p-2 overflow-auto "
    />
  );
};


export default OrderItemsTable;
